import React, { useEffect, useState } from "react";
import Images from "../../utils/images";
import { Link, Navigate, useNavigate } from "react-router-dom";

import MessageBar, {
  DOBASEURL,
  config,
  errorNotify,
  getValueFromLocalStorage,
  localStorageKey,
  successNotify,
} from "../../utils/helper";
import { FaUserTimes } from "react-icons/fa";
import { FaUserCheck } from "react-icons/fa6";
import { authorizedGet, authorizedPost } from "../../Config/networkWithToken";
import configuration from "../../Config/configuration";
import Strings from "../../utils/Strings";
import { useParams } from "react-router-dom";
import Spinner from "../../Components/Spinner/Spinner";
import { GoDotFill } from "react-icons/go";
import RejectModel from "../../Components/RejectModel/RejectModel";

const RequestDetails = ({ request }) => {
  const adminId = getValueFromLocalStorage(localStorageKey.USERDATA, "adminId");
  const { userId } = useParams();
  const [User, setUserData] = useState([]);
  const [sendRequest, setSendRequests] = useState([]);
  const [receivedRequest, setReceiveRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingAcceptRequestId, setLoadingAcceptRequestId] = useState(null);
  const [loadingDenyRequestId, setLoadingDenyRequestId] = useState(null);
  const [approve, setApprove] = useState(null);
  const [reject, setReject] = useState(null);
  const [approvedRequests, setApprovedRequests] = useState({});
  const [rejectedRequests, setRejectedRequests] = useState({});
  const [isCommentSectionOpen, setIsCommentSectionOpen] = useState(false);
  const [error, setError] = useState(false);
  const [comment, setComment] = useState("");
  const [requestedId, setRequestedId] = useState(null);
  const [showRevokeConfirmation, setShowRevokeConfirmation] = useState(false);
  const [revoking, setRevoking] = useState(false);
  const [revokeRequestId, setRevokeRequestId] = useState(null);
  const [sendButtonStatus, setSendButtonStatus] = useState({});
  const [potentialMatches, setPotentialMatches] = useState([]);
  const [loadingMatchId, setLoadingMatchId] = useState(null);
  const [buttonStatus, setButtonStatus] = useState({});

  useEffect(() => {
    requestDetails();
    fetchMatchUser();
  }, []);

  const tabList = [
    { name: "User Requests" },
    { name: "Accepted Requests" },
    { name: "Denied Requests" },
  ];

  const requestDetails = async () => {
    setLoading(true);
    try {
      const res = await authorizedGet(
        `${configuration.apis.requestDetail}?adminId=${adminId}&userId=${userId}`,
        config,
      );
      console.log("jhgdgjhc", res);
      const response = res?.data;
      if (response?.status) {
        setUserData(response?.data?.userData);
        setSendRequests(response?.data?.sendRequest);
        setReceiveRequests(response?.data?.receiveRequest);
      }
    } catch (error) {
      errorNotify(Strings.ERROR);
    } finally {
      setLoading(false);
    }
  };

  const handleApproval = async (decision, requestId) => {
    try {
      if (decision === "approve") {
        setLoadingAcceptRequestId(requestId);
      } else if (decision === "reject") {
        setIsCommentSectionOpen(true);
      }

      const data = {
        adminId: adminId,
        requestId: requestId,
        action:
          decision === "approve"
            ? Strings.APPROVE
            : decision === "reject"
              ? Strings.REJECT
              : "", // default fallback
        comments: comment,
      };

      const res = await authorizedPost(
        configuration.apis.adminApproval,
        data,
        config,
      );

      if (res?.data?.status) {
        successNotify(res?.data?.message);

        if (decision === "approve") {
          setApprovedRequests((prev) => ({ ...prev, [requestId]: true }));
          setRejectedRequests((prev) => ({ ...prev, [requestId]: false }));
        } else {
          setRejectedRequests((prev) => ({ ...prev, [requestId]: true }));
          setApprovedRequests((prev) => ({ ...prev, [requestId]: false }));
        }
        await requestDetails();
      } else {
        errorNotify(res?.data?.message);
      }
    } catch (error) {
      errorNotify(Strings.ERROR);
    } finally {
      setLoadingAcceptRequestId(null);
      setLoadingDenyRequestId(null);
      setIsCommentSectionOpen(false);
      setComment("");
      setError(false);
    }
  };

  const navigate = useNavigate();

  // function to go back to the last URL
  const handleGoBack = () => {
    navigate(-1);
  };

  const handleAction = (decision, requestedId) => {
    setRequestedId(requestedId);
    if (decision === "approve") {
      handleApproval(decision, requestedId);
    } else {
      setIsCommentSectionOpen(true);
    }
  };
  const handleRejectAction = (requestedId, comment) => {
    const adminName = getValueFromLocalStorage(
      localStorageKey.USERDATA,
      "name",
    );
    const rejectedAt = new Date().toISOString();
    setSendRequests((prev) =>
      prev.map((user) =>
        user.requestId === requestedId
          ? {
              ...user,
              adminApproval: false,
              adminReject: true,
              comments: comment,
              admin: adminName,
              adminRejectedAt: rejectedAt,
            }
          : user,
      ),
    );

    setReceiveRequests((prev) =>
      prev.map((user) =>
        user.requestId === requestedId
          ? {
              ...user,
              adminApproval: false,
              adminReject: true,
              comments: comment,
              admin: adminName,
              adminRejectedAt: rejectedAt,
            }
          : user,
      ),
    );
  };

  const handleSaveComment = () => {
    if (comment.length < 15) {
      setError(true);
    } else {
      handleApproval("reject", requestedId);
      handleRejectAction(requestedId, comment);
      setIsCommentSectionOpen(false);
      setError(false);
      setComment("");
    }
  };

  const handleNoteChange = (event) => {
    setError(false);
    setComment(event.target.value);
  };

  const closeModal = () => {
    setComment("");
    setError(false);
    setIsCommentSectionOpen(false);
  };

  const confirmrevokeuser = async () => {
    if (!revokeRequestId) return;
    setRevoking(true);

    await handleAction("approve", revokeRequestId);

    setSendRequests((prev) =>
      prev.map((user) =>
        user.requestId === revokeRequestId
          ? { ...user, adminApproval: true, adminReject: false }
          : user,
      ),
    );

    setReceiveRequests((prev) =>
      prev.map((user) =>
        user.requestId === revokeRequestId
          ? { ...user, adminApproval: true, adminReject: false }
          : user,
      ),
    );

    setRevoking(false);
    setShowRevokeConfirmation(false);
    setRevokeRequestId(null);
  };

  const fetchMatchUser = async () => {
    setLoading(true);
    try {
      const res = await authorizedGet(
        `${configuration.apis.matches}?userId=${userId}`,
        config,
      );
      const response = res?.data?.data;

      if (response) {
        if (response.length > 0) {
          const newButtonStatus = {};
          const users = [];

          response.forEach((list) => {
            if (list?.maritalStatus !== "married") {
              if (
                list?.requestStatus === null ||
                list?.requestStatus === "Rejected"
              ) {
                if (
                  list?.suggestionStatus === null ||
                  list?.suggestionStatus === "Rejected" ||
                  list?.match
                ) {
                  users.push(list);
                }
              }
              if (list?.match?.Userdecision) {
                if (
                  list?.match?.Userdecision === "accepted" &&
                  list?.match?.matchedUserdecision === "accepted"
                ) {
                  newButtonStatus[list._id] = "Accepted";
                } else if (
                  list?.match?.Userdecision === "rejected" ||
                  list?.match?.matchedUserdecision === "rejected"
                ) {
                  newButtonStatus[list._id] = "Rejected";
                } else {
                  newButtonStatus[list._id] = "Pending";
                }
                // newButtonStatus[list._id] = list?.suggestionStatus || "Send Match";
              }
            }
          });
          setSendButtonStatus(newButtonStatus);
          setPotentialMatches(users);
        }
      }
    } catch (err) {
      // console.log("Error fetching data:", err);
    }
    setLoading(false);
  };

  const handleSendMatch = async (matchedUserId) => {
    setLoadingMatchId(matchedUserId);
    try {
      const data = {
        userId: userId,
        matchedUser: matchedUserId,
        adminId: adminId,
      };
      // console.log(data);
      const res = await authorizedPost(
        configuration.apis.sendMatches,
        data,
        config,
      );
      const response = res?.data?.data;
      if (res?.data?.status) {
        successNotify(res?.data?.message);
        setButtonStatus((prevStatus) => ({
          ...prevStatus,
          [matchedUserId]: true,
        }));
        // send notification
        // socket.emit("suggestion", "suggesstion send to the user");

        if (response && response.length > 0) {
          response.map((value) => {
            if (matchedUserId === value?._id) {
              setSendButtonStatus((prevStatus) => ({
                ...prevStatus,
                [value?._id]: value?.match?.decision,
              }));
            }
          });
        }
      } else {
        errorNotify(res?.data?.message);
      }
    } catch (err) {
      errorNotify(Strings.ERROR);
      //console.log("Error sending match:", err);
    }
    setLoadingMatchId(null);
  };

  const potentialMatchesPagniationData = potentialMatches.slice();

  return (
    <div className="p-4">
      {/* Show Loading Spinner */}
      {loading ? (
        <div className="flex min-h-screen flex-col items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <>
          {/* Profile Header */}
          <div className="mb-[30px] flex flex-col items-center sm:flex-row sm:justify-between">
            <div className="hidden h-[100px] w-[240px] items-center gap-4 rounded-[15px] border bg-white p-3 shadow-md sm:flex  lg:w-[240px]">
              <div className="flex flex-col justify-between">
                <p className="mb-2 text-sm text-gray-600">
                  <span className="font-semibold text-black">
                    Send Proposal Count:{" "}
                  </span>
                  {sendRequest?.length}
                </p>
                <p className="text-sm text-gray-600">
                  <span className="font-semibold text-black">
                    Users Proposal Count:{" "}
                  </span>
                  {receivedRequest.length}
                </p>
              </div>
            </div>

            {/* User Profile Card */}
            <div className="flex h-[140px] w-[340px] items-center gap-4 rounded-[15px] border bg-white p-3 shadow-md lg:w-[340px]">
              <div></div>
              <div className="flex h-auto w-auto rounded-full">
                <Link to={`/user-request/viewProfile/${User.id}`}>
                  <img
                    className="h-[100px] w-[100px] rounded-full object-cover"
                    src={
                      User?.photos?.images?.length > 0
                        ? DOBASEURL + User?.photos?.images[0]
                        : Images.DEFAULT_USER
                    }
                    alt="User Profile"
                  />
                </Link>
              </div>
              <div className="flex flex-col justify-between">
                <p className="mb-2 text-[18px] font-semibold">{User.name}</p>
                <p className="mb-2 text-sm text-gray-600">
                  <span className="font-semibold text-black">Age: </span>
                  {User.age}
                </p>
                <p className="text-sm text-gray-600">
                  <span className="font-semibold text-black">
                    Marital Status:{" "}
                  </span>
                  {User.maritalStatus}
                </p>
              </div>
            </div>

            <div className="hidden sm:flex">
              <p
                onClick={handleGoBack}
                className="ml-auto cursor-pointer text-blue-600 underline"
              >
                Back
              </p>
            </div>
          </div>

          <div>
            <div className="grid w-[100%] grid-cols-1  gap-6 md:grid-cols-1 lg:grid-cols-3 ">
              <div className=" borderpb-4 items-start justify-start rounded-lg pl-4 pr-4 pt-4  ">
                <h2 className="mb-5 flex items-center justify-center text-[25px]  text-textGreen underline">
                  Sent Proposal
                </h2>

                {sendRequest.length === 0 ? (
                  <p className="col-span-3 text-center  font-normal text-gray-500">
                    No Send Proposal is found
                  </p>
                ) : (
                  <div className="mt-2 grid grid-cols-1 gap-4">
                    {sendRequest.map((user) => (
                      <div
                        key={user?.id}
                        className=" rounded-[15px] border bg-white p-3 shadow-md"
                      >
                        <div className="tems-center flex justify-between gap-4 ">
                          <div className="flex flex-1 flex-col">
                            <div className="flex w-full flex-col items-center justify-center">
                              <Link
                                to={`/user-request/viewProfile/${user?.id}`}
                              >
                                <img
                                  className="mb-4 h-28 w-28 rounded-full object-cover sm:h-20 sm:w-20 md:mb-0 md:mr-4 md:h-16 md:w-16"
                                  src={
                                    user?.photos?.images?.length > 0
                                      ? DOBASEURL + user?.photos?.images[0]
                                      : Images.DEFAULT_USER
                                  }
                                  alt="User Profile"
                                />
                              </Link>
                            </div>
                            <p className="mb-2 pl-4 text-[18px] font-semibold">
                              {user?.name}
                            </p>
                            <p className="mb-2 pl-4 text-sm text-gray-600">
                              <span className="font-semibold text-black ">
                                Age:{" "}
                              </span>
                              {user?.age}
                            </p>
                            <p className="pl-4 text-sm text-gray-600">
                              <span className="font-semibold text-black">
                                Marital Status:{" "}
                              </span>
                              {user?.maritalStatus}
                            </p>
                          </div>
                        </div>
                        {(user?.adminApproval === true ||
                          user?.adminReject === true ||
                          user?.userReject === true) && (
                          <div className="w-full px-4 text-left">
                            <p className="text-bg-black text-left text-xs font-semibold">
                              {user?.adminReject === true
                                ? "Rejected By:"
                                : "Accepted By:"}
                              <span className="font-normal">
                                {" "}
                                {user?.admin}
                              </span>
                            </p>

                            <p className="text-bg-black text-xs font-semibold">
                              {user?.adminReject === true
                                ? "Admin Rejected Date:"
                                : "Admin Accepted Date:"}
                              <span className="font-normal">
                                {user?.adminReject === true
                                  ? user?.adminRejectedAt
                                    ? new Date(
                                        user?.adminRejectedAt,
                                      ).toLocaleDateString("en-GB")
                                    : "N/A"
                                  : user?.adminApprovedAt
                                    ? new Date(
                                        user?.adminApprovedAt,
                                      ).toLocaleDateString("en-GB")
                                    : "N/A"}
                              </span>
                            </p>

                            {user?.adminApproval === true &&
                              user?.userApproval === true && (
                                <div className="text-left text-xs font-semibold">
                                  <p className="text-bg-black">
                                    User Approved Date:{" "}
                                    <span className="font-normal">
                                      {user?.userApprovedAt
                                        ? new Date(
                                            user?.userApprovedAt,
                                          ).toLocaleDateString("en-GB")
                                        : "N/A"}
                                    </span>
                                  </p>
                                </div>
                              )}

                            {((user?.adminReject === true &&
                              user?.userReject === true) ||
                              (user?.adminReject === false &&
                                user?.userReject === true) ||
                              (user?.adminReject === true &&
                                user?.userReject === false)) && (
                              <>
                                <p className="text-bg-black text-left text-xs font-semibold">
                                  User Rejected Date:{" "}
                                  <span className="font-normal">
                                    {user?.userRejectedAt
                                      ? new Date(
                                          user.userRejectedAt,
                                        ).toLocaleDateString("en-GB")
                                      : "N/A"}
                                  </span>
                                </p>
                                <div className="relative flex items-center gap-2">
                                  {!isCommentSectionOpen && (
                                    <>
                                      <p className="text-bg-black whitespace-nowrap text-xs font-semibold">
                                        Rejected Reason:
                                      </p>
                                      <p className="max-w-[15rem] truncate text-xs font-normal text-red-500">
                                        {user?.comments || "N/A"}
                                      </p>
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        )}
                        <div className="flex flex-col gap-2">
                          {user?.adminApproval === false &&
                          user?.adminReject === false ? (
                            <>
                              {approvedRequests[user?.requestId] ? (
                                //  Approved UI
                                <div className="relative">
                                  <div className="absolute right-1 top-[-220px] flex flex-col items-center sm:top-[-190px] md:top-[-200px] lg:top-[-180px]">
                                    {" "}
                                    <button
                                      className="rounded-full bg-red-500 p-2 text-white hover:bg-red-700"
                                      onClick={() => {
                                        setRequestedId(user?.requestId);
                                        setIsCommentSectionOpen(true);
                                        setComment("");
                                      }}
                                    >
                                      <FaUserTimes size={16} />
                                    </button>
                                  </div>

                                  {/* Accepted Icon + Text Centered */}
                                  <div className="flex h-full flex-col items-center justify-center pt-12">
                                    <button className="mt-2 rounded-full bg-green-500 p-2 text-white hover:bg-green-700">
                                      <FaUserCheck size={18} />
                                    </button>
                                    <p className="mt-2 text-sm">Accepted</p>
                                  </div>
                                </div>
                              ) : rejectedRequests[user?.requestId] ? (
                                <div className="flex items-center justify-center gap-10">
                                  <button className="rounded-full bg-red-500 p-2 text-white hover:bg-red-800">
                                    <FaUserTimes size={18} />
                                  </button>
                                  <button
                                    className="mt-2 rounded-full bg-blue-500 p-2 text-white hover:bg-blue-700"
                                    onClick={() => {
                                      setRevokeRequestId(user?.requestId);
                                      setShowRevokeConfirmation(true);
                                    }}
                                  >
                                    <FaUserCheck size={18} />
                                  </button>
                                </div>
                              ) : (
                                //  Neutral State - Show Accept / Reject
                                <div className="mt-4 flex w-full items-center justify-center gap-10">
                                  <button
                                    className={`hover:bg-green-700" rounded-full bg-green-500 p-2 text-white ${
                                      loadingAcceptRequestId === user?.requestId
                                        ? "cursor-not-allowed opacity-50"
                                        : ""
                                    }`}
                                    onClick={() =>
                                      handleAction("approve", user?.requestId)
                                    }
                                    disabled={
                                      loadingAcceptRequestId === user?.requestId
                                    }
                                  >
                                    {loadingAcceptRequestId ===
                                    user?.requestId ? (
                                      <Spinner className="h-5 w-5" />
                                    ) : (
                                      <FaUserCheck size={18} />
                                    )}
                                  </button>
                                  <button
                                    className=" rounded-full bg-red-500 p-2 text-white hover:bg-red-700"
                                    onClick={() =>
                                      handleAction("reject", user?.requestId)
                                    }
                                  >
                                    <FaUserTimes size={18} />
                                  </button>
                                </div>
                              )}
                            </>
                          ) : (
                            <>
                              {/*  Show if Already Approved */}
                              {user?.adminApproval && !user?.adminReject && (
                                <div className="relative">
                                  <div className="absolute right-1 top-[-220px] flex flex-col items-center sm:top-[-190px] md:top-[-200px] lg:top-[-180px]">
                                    <button
                                      className="rounded-full bg-red-500 p-2 text-white hover:bg-red-700"
                                      onClick={() => {
                                        setRequestedId(user?.requestId);
                                        setIsCommentSectionOpen(true);
                                        setComment("");
                                      }}
                                    >
                                      <FaUserTimes size={16} />
                                    </button>
                                  </div>

                                  {/* Accepted Icon + Text Centered */}
                                  <div className="flex h-full flex-col items-center justify-center pt-12">
                                    <button className="mt-2 rounded-full bg-green-500 p-2 text-white hover:bg-green-700">
                                      <FaUserCheck size={18} />
                                    </button>
                                    <p className="mt-2 text-sm">Accepted</p>
                                  </div>
                                </div>
                              )}

                              {/*  Show if Already Rejected */}
                              {user?.adminReject && (
                                <>
                                  <div className="mt-3 flex items-center justify-center gap-10">
                                    <div className="flex flex-col items-center justify-center">
                                      <button className="rounded-full bg-red-500 p-2 text-white hover:bg-red-800">
                                        <FaUserTimes size={18} />
                                      </button>
                                    </div>
                                    <div className="flex flex-col items-center justify-center">
                                      <button
                                        className=" rounded-full bg-blue-500 p-2 text-white hover:bg-blue-700"
                                        onClick={() => {
                                          setRevokeRequestId(user?.requestId);
                                          setShowRevokeConfirmation(true);
                                        }}
                                      >
                                        <FaUserCheck size={18} />
                                      </button>
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Requested Users Section */}
              <div className="mb-2 rounded-lg   p-4 text-[18px]  ">
                <h2 className="mb-6 text-center text-[25px] text-textGreen underline">
                  User Proposal
                </h2>

                {receivedRequest.length === 0 ? (
                  <p className="col-span-3 text-center font-normal text-gray-500 ">
                    No User Proposal is found
                  </p>
                ) : (
                  <div className="mt-2 grid grid-cols-1 gap-4">
                    {receivedRequest.map((user) => (
                      <div
                        key={user.id}
                        className=" rounded-[15px] border bg-white p-3 shadow-md"
                      >
                        <div className="flex items-center justify-between gap-4">
                          <div className="flex h-auto w-auto rounded-full">
                            <div className="flex h-auto w-auto rounded-full"></div>
                          </div>

                          <div className="flex flex-1 flex-col">
                            <div className="flex w-full flex-col items-center justify-center">
                              <Link
                                to={`/user-request/viewProfile/${user?.id}`}
                              >
                                <img
                                  className="mb-4 h-28 w-28 rounded-full object-cover sm:h-20 sm:w-20 md:mb-0 md:mr-4 md:h-16 md:w-16"
                                  src={
                                    user?.photos?.images?.length > 0
                                      ? DOBASEURL + user?.photos?.images[0]
                                      : Images.DEFAULT_USER
                                  }
                                  alt="User Profile"
                                />
                              </Link>
                            </div>

                            <p className="mb-2 text-[18px] font-semibold">
                              {user.name}
                            </p>
                            <p className="mb-2 text-sm text-gray-600">
                              <span className="font-semibold text-black">
                                Age:{" "}
                              </span>
                              {user.age}
                            </p>
                            <p className="text-sm text-gray-600">
                              <span className="font-semibold text-black">
                                Marital Status:{" "}
                              </span>
                              {user.maritalStatus}
                            </p>
                          </div>
                        </div>
                        {(user?.adminApproval === true ||
                          user?.adminReject === true ||
                          user?.userReject === true) && (
                          <div className="w-full px-4 text-left">
                            <p className="text-bg-black text-left text-xs font-semibold">
                              {user?.adminReject === true
                                ? "Rejected By:"
                                : "Accepted By:"}
                              <span className="font-normal">
                                {" "}
                                {user?.admin}
                              </span>
                            </p>

                            <p className="text-bg-black text-xs font-semibold">
                              {user?.adminReject === true
                                ? "Admin Rejected Date:"
                                : "Admin Accepted Date:"}
                              <span className="font-normal">
                                {user?.adminReject === true
                                  ? user?.adminRejectedAt
                                    ? new Date(
                                        user?.adminRejectedAt,
                                      ).toLocaleDateString("en-GB")
                                    : "N/A"
                                  : user?.adminApprovedAt
                                    ? new Date(
                                        user?.adminApprovedAt,
                                      ).toLocaleDateString("en-GB")
                                    : "N/A"}
                              </span>
                            </p>

                            {user?.adminApproval === true &&
                              user?.userApproval === true && (
                                <div className="text-left text-xs font-semibold">
                                  <p className="text-bg-black">
                                    User Approved Date:{" "}
                                    <span className="font-normal">
                                      {user?.userApprovedAt
                                        ? new Date(
                                            user?.userApprovedAt,
                                          ).toLocaleDateString("en-GB")
                                        : "N/A"}
                                    </span>
                                  </p>
                                </div>
                              )}

                            {((user?.adminReject === true &&
                              user?.userReject === true) ||
                              (user?.adminReject === false &&
                                user?.userReject === true) ||
                              (user?.adminReject === true &&
                                user?.userReject === false)) && (
                              <>
                                <p className="text-bg-black text-left text-xs font-semibold">
                                  User Rejected Date:{" "}
                                  <span className="font-normal">
                                    {user?.userRejectedAt
                                      ? new Date(
                                          user.userRejectedAt,
                                        ).toLocaleDateString("en-GB")
                                      : "N/A"}
                                  </span>
                                </p>
                                <div className="relative flex items-center gap-2">
                                  {!isCommentSectionOpen && (
                                    <>
                                      <p className="text-bg-black whitespace-nowrap text-xs font-semibold">
                                        Rejected Reason:
                                      </p>
                                      <p className="max-w-[15rem] truncate text-xs font-normal text-red-500">
                                        {user?.comments || "N/A"}
                                      </p>
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        )}
                        {/* Icons based on acceptance/rejection status */}
                        <div className="flex flex-col gap-2">
                          {user?.adminApproval === false &&
                          user?.adminReject === false ? (
                            <>
                              {approvedRequests[user?.requestId] ? (
                                //  Approved UI
                                <div className="relative">
                                  <div className="absolute right-1 top-[-220px] flex flex-col items-center sm:top-[-190px] md:top-[-200px] lg:top-[-180px]">
                                    {" "}
                                    <button
                                      className="rounded-full bg-red-500 p-2 text-white hover:bg-red-700"
                                      onClick={() => {
                                        setRequestedId(user?.requestId);
                                        setIsCommentSectionOpen(true);
                                        setComment("");
                                      }}
                                    >
                                      <FaUserTimes size={16} />
                                    </button>
                                  </div>

                                  {/* Accepted Icon + Text Centered */}
                                  <div className="flex h-full flex-col items-center justify-center pt-12">
                                    <button className="mt-2 rounded-full bg-green-500 p-2 text-white hover:bg-green-700">
                                      <FaUserCheck size={18} />
                                    </button>
                                    <p className="mt-2 text-sm">Accepted</p>
                                  </div>
                                </div>
                              ) : rejectedRequests[user?.requestId] ? (
                                <div className="flex items-center justify-center gap-10">
                                  <button className="rounded-full bg-red-500 p-2 text-white hover:bg-red-800">
                                    <FaUserTimes size={18} />
                                  </button>
                                  <button
                                    className="mt-2 rounded-full bg-blue-500 p-2 text-white hover:bg-blue-700"
                                    onClick={() => {
                                      setRevokeRequestId(user?.requestId);
                                      setShowRevokeConfirmation(true);
                                    }}
                                  >
                                    <FaUserCheck size={18} />
                                  </button>
                                </div>
                              ) : (
                                //  Neutral State - Show Accept / Reject
                                <div className="mt-4 flex w-full items-center justify-center gap-10">
                                  <button
                                    className={`hover:bg-green-700" rounded-full bg-green-500 p-2 text-white ${
                                      loadingAcceptRequestId === user?.requestId
                                        ? "cursor-not-allowed opacity-50"
                                        : ""
                                    }`}
                                    onClick={() =>
                                      handleAction("approve", user?.requestId)
                                    }
                                    disabled={
                                      loadingAcceptRequestId === user?.requestId
                                    }
                                  >
                                    {loadingAcceptRequestId ===
                                    user?.requestId ? (
                                      <Spinner className="h-5 w-5" />
                                    ) : (
                                      <FaUserCheck size={18} />
                                    )}
                                  </button>
                                  <button
                                    className=" rounded-full bg-red-500 p-2 text-white hover:bg-red-700"
                                    onClick={() =>
                                      handleAction("reject", user?.requestId)
                                    }
                                  >
                                    <FaUserTimes size={18} />
                                  </button>
                                </div>
                              )}
                            </>
                          ) : (
                            <>
                              {/*  Show if Already Approved */}
                              {user?.adminApproval && !user?.adminReject && (
                                <div className="relative">
                                  <div className="absolute right-1 top-[-220px] flex flex-col items-center sm:top-[-190px] md:top-[-200px] lg:top-[-180px]">
                                    <button
                                      className="rounded-full bg-red-500 p-2 text-white hover:bg-red-700"
                                      onClick={() => {
                                        setRequestedId(user?.requestId);
                                        setIsCommentSectionOpen(true);
                                        setComment("");
                                      }}
                                    >
                                      <FaUserTimes size={16} />
                                    </button>
                                  </div>

                                  {/* Accepted Icon + Text Centered */}
                                  <div className="flex h-full flex-col items-center justify-center pt-12">
                                    <button className="mt-2 rounded-full bg-green-500 p-2 text-white hover:bg-green-700">
                                      <FaUserCheck size={18} />
                                    </button>
                                    <p className="mt-2 text-sm">Accepted</p>
                                  </div>
                                </div>
                              )}

                              {/*  Show if Already Rejected */}
                              {user?.adminReject && (
                                <>
                                  <div className="mt-3 flex items-center justify-center gap-10">
                                    <div className="flex flex-col items-center justify-center">
                                      <button className="rounded-full bg-red-500 p-2 text-white hover:bg-red-800">
                                        <FaUserTimes size={18} />
                                      </button>
                                    </div>
                                    <div className="flex flex-col items-center justify-center">
                                      <button
                                        className=" rounded-full bg-blue-500 p-2 text-white hover:bg-blue-700"
                                        onClick={() => {
                                          setRevokeRequestId(user?.requestId);
                                          setShowRevokeConfirmation(true);
                                        }}
                                      >
                                        <FaUserCheck size={18} />
                                      </button>
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className=" borderpb-4 items-start justify-start rounded-lg pl-4 pr-4 pt-4  ">
                <h2 className="mb-5 flex items-center justify-center text-[25px]  text-textGreen underline">
                  Potential Matches
                </h2>
                {potentialMatches.length === 0 ? (
                  <p className="col-span-3 text-center  font-normal text-gray-500">
                    No Matches is found
                  </p>
                ) : (
                  potentialMatches?.map((item, index) => (
                    <li
                      key={index}
                      className="mb-4 flex flex-col items-center justify-between rounded-lg border border-gray-200 bg-white p-4"
                    >
                      <div className="flex w-full flex-col items-center md:flex-row">
                        <div className="font-jost flex-1 text-center md:text-left">
                          <div className="flex w-full flex-col items-center justify-center">
                            <Link
                              to={`/matrimony/${1}/viewProfile/${item._id || item?.userId}`}
                            >
                              <img
                                src={
                                  item?.photos?.length > 0
                                    ? DOBASEURL + item?.photos?.[0]
                                    : item?.gender === "male"
                                      ? Images.MEN
                                      : Images.WOMEN
                                }
                                className="mb-4 h-28 w-28 rounded-full object-cover sm:h-20 sm:w-20 md:mb-0 md:mr-4 md:h-20 md:w-20"
                                alt=""
                                onContextMenu={(e) => e.preventDefault()}
                                onDragStart={(e) => e.preventDefault()}
                              />
                            </Link>
                          </div>
                          <div className="text-lg">{item?.name}</div>
                          <div className="flex items-center justify-center md:justify-start">
                            <GoDotFill className="mr-2 text-sm text-textBlack" />
                            Age: {item?.age}
                          </div>
                          <div className="flex items-center justify-center md:justify-start">
                            <GoDotFill className="mr-2 text-sm text-textBlack" />
                            Gender: {item?.gender}
                          </div>
                          <div className="flex items-center justify-center md:justify-start">
                            <GoDotFill className="mr-2 text-sm text-textBlack" />
                            Marital Status: {item?.maritalStatus}
                          </div>
                          <div className="flex items-center justify-center md:justify-start">
                            <GoDotFill className="mr-2 text-sm text-textBlack" />
                            Expectated Match Count: {item?.matchCount}
                          </div>
                        </div>
                      </div>

                      {/* 🔻 Button goes below the content now */}
                      <div className="mt-4 flex w-full flex-col items-center justify-center gap-4 sm:flex-row">
                        {buttonStatus[item._id] ? (
                          <button className="font-jost w-full rounded-lg bg-textYellow px-4 py-2 text-white sm:w-auto">
                            Pending
                          </button>
                        ) : (
                          <button
                            className="font-jost flex w-full items-center justify-center rounded-lg bg-textYellow px-4 py-2 text-white sm:w-auto"
                            onClick={() => handleSendMatch(item._id)}
                            disabled={
                              loadingMatchId === item._id ||
                              sendButtonStatus[item._id]
                            }
                          >
                            {loadingMatchId === item._id ? (
                              <Spinner size={16} />
                            ) : sendButtonStatus[item._id] === undefined ? (
                              "Send Match"
                            ) : (
                              sendButtonStatus[item._id]
                            )}
                          </button>
                        )}
                      </div>
                    </li>
                  ))
                )}
              </div>
            </div>
            <div className="mt-5 flex items-center justify-center">
              <p className="text-xs text-gray-400">
                Click profile to see full details
              </p>
              {isCommentSectionOpen && (
                <div className="popup-container fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-10">
                  <RejectModel
                    setComment={setComment}
                    comment={comment}
                    handleNoteChange={handleNoteChange}
                    closeModal={closeModal}
                    error={error}
                    handleSaveComment={handleSaveComment}
                  />
                </div>
              )}
            </div>
            {/* Revoke Confirmation Modal */}
            {showRevokeConfirmation && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <div className="w-[90%] rounded-lg bg-white p-4 shadow-lg sm:w-[60%] md:w-[40%]">
                  <p className="mb-4 text-center text-sm sm:text-base">
                    {Strings.USER_REVOKE}
                  </p>
                  <div className="flex justify-around">
                    <button
                      onClick={confirmrevokeuser}
                      className="rounded bg-blue-500 px-4 py-2 text-white"
                    >
                      {revoking ? <Spinner size="small" /> : "Yes, Revoke"}
                    </button>
                    <button
                      onClick={() => {
                        setShowRevokeConfirmation(false);
                        setRevokeRequestId(null);
                      }}
                      className="rounded bg-gray-300 px-4 py-2"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <MessageBar />
        </>
      )}
    </div>
  );
};

export default RequestDetails;
